import * as React from 'react'

const MenuDots = props => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.333 15.833c0 .917.75 1.667 1.667 1.667.916 0 1.666-.75 1.666-1.667 0-.916-.75-1.666-1.666-1.666-.917 0-1.667.75-1.667 1.666zM8.333 4.165c0 .917.75 1.667 1.667 1.667.916 0 1.666-.75 1.666-1.667 0-.916-.75-1.666-1.666-1.666-.917 0-1.667.75-1.667 1.666zM8.333 10.001c0 .917.75 1.667 1.667 1.667.916 0 1.666-.75 1.666-1.667 0-.916-.75-1.666-1.666-1.666-.917 0-1.667.75-1.667 1.666z"
        stroke="#4F5B94"
        strokeWidth={1.5}
      />
    </svg>
  )
}

export default MenuDots
